import SvgColor from "components/svg-color/SvgColor";
import { PATH_DASHBOARD } from "routes/paths";

export const PATH_ROUTE = {
  dashboard: PATH_DASHBOARD.app,
  Master: "/app/master",
  course: PATH_DASHBOARD.courses,
  language: PATH_DASHBOARD.language,
  board: PATH_DASHBOARD.board,
  class: PATH_DASHBOARD.class,
  batchtype: PATH_DASHBOARD.batchtype,
  stream: PATH_DASHBOARD.stream,
  goalmapping: PATH_DASHBOARD.goalmapping,
  subject: PATH_DASHBOARD.subject,
  chapter: PATH_DASHBOARD.chapter,
  banner: PATH_DASHBOARD.banner,
  state: PATH_DASHBOARD.state,
  city: PATH_DASHBOARD.city,
  grievancesCategory: PATH_DASHBOARD.grievancescategory,
  product: PATH_DASHBOARD.productpackage,
  "Free Resource": "/app/freeresource",
  pyqs: PATH_DASHBOARD.pyqslist,
  modalpaper: PATH_DASHBOARD.modalpaper,
  "Spoken English": "/app/spokenenglish",
  questionoftheday: PATH_DASHBOARD.questionoftheday,
  wordoftheday: PATH_DASHBOARD.wordoftheday,
  vocabulary: PATH_DASHBOARD.vocabulary,
  idioms: PATH_DASHBOARD.idioms,
  grammar: PATH_DASHBOARD.grammar,
  mastercurriculum: PATH_DASHBOARD.mastercurriculum,
  curriculumcontent: PATH_DASHBOARD.curriculumcontent,
  dailyusesentences: PATH_DASHBOARD.dailyusesentences,
  masterdailyusesentences: PATH_DASHBOARD.masterdailysentences,
  grievancesSubcategory: PATH_DASHBOARD.grievancessubcategory,
  wanttobe: PATH_DASHBOARD.wanttobe,
  imagesbookmark: PATH_DASHBOARD.imagesbookmark,
  roles: PATH_DASHBOARD.roles,
  Syllabus: "/app/syllabus",
  topic: PATH_DASHBOARD.topic,
  videomanager: PATH_DASHBOARD.content,
  uploadbulktopic: PATH_DASHBOARD.bulkupload,
  uploadbulkvideo: PATH_DASHBOARD.bulkuploadvideo,
  "Student Manager": "/app/student-manager",
  studentlist: PATH_DASHBOARD.student,
  Rating: PATH_DASHBOARD.ratings,
  appratings: "/app/ratings/app-ratings",
  uploadbulkstudent: PATH_DASHBOARD.studentbulkupload,
  studentcallrequest: PATH_DASHBOARD.StudentRequest,
  "Educator Ratings": "/app/educator-ratings",
  feedback: PATH_DASHBOARD.feedback,
  liveclassratings: "/app/educator-ratings/liveclass-ratings",
  orders: PATH_DASHBOARD.order,
  payments: PATH_DASHBOARD.payment,
  Staff: "/app/staff-manager",
  stafflist: PATH_DASHBOARD.staff,
  uploadbulkstaff: PATH_DASHBOARD.bulkuploadstaff,
  shorts: PATH_DASHBOARD.short,
  grievances: PATH_DASHBOARD.grievances,
  schedules: PATH_DASHBOARD.schedule,
  faq: PATH_DASHBOARD.faq,
  onlyforyou: PATH_DASHBOARD.onlyforyou,
  notice: PATH_DASHBOARD.notice,
  doubts: PATH_DASHBOARD.doubts,
  Revision: "/app/revision",
  revisionlist: PATH_DASHBOARD.revision,
  uploadbulkrevision: PATH_DASHBOARD.uploadbulk,
  "Question Bank": "/app/questionbank",
  questionbank: "/app/questionbank",
  questionbanklist: PATH_DASHBOARD.questionbank,
  questionbulkupload: PATH_DASHBOARD.questionbulkupload,
  Scholarship: "/app/scholarship",
  createscholarship: PATH_DASHBOARD.scholarship,
  createscholarshipclass: PATH_DASHBOARD.scholarshipclass,
  scholarshiptest: PATH_DASHBOARD.scholarshiptest,
  createscholarshiptest: PATH_DASHBOARD.createscholarshiptest,
  tophighlight: PATH_DASHBOARD.tophighlight,
  Assignment: "/app/assignment",
  createassignment: PATH_DASHBOARD.assignment,
  assignmentresult: PATH_DASHBOARD.assignmentresult,
  scholarshipapplication: PATH_DASHBOARD.scholorshipapplication,
  Test: "/app/test",
  createtest: PATH_DASHBOARD.testquestion,
  testreport: PATH_DASHBOARD.testreport,
  studentowntest: PATH_DASHBOARD.studentowntest,
  quizreport: PATH_DASHBOARD.quizreportlist,
  Mentorship: "/app/mentorship",
  features: PATH_DASHBOARD.feature,
  howithelp: PATH_DASHBOARD.howithelp,
  whyyouneed: PATH_DASHBOARD.whyyouneed,
  mentorshippackage: PATH_DASHBOARD.mentorshippackage,
  practicetest: PATH_DASHBOARD.testpractice,
  mastertest: PATH_DASHBOARD.testmaster,
  "General Setting": "/app/general-setting",
  instruction: PATH_DASHBOARD.instruction,
  paymentsetting: PATH_DASHBOARD.paymentsetting,
  sitesetting: PATH_DASHBOARD.sitesetting,
  individualsetting: PATH_DASHBOARD.indivisualsetting,
  zoomsetting: PATH_DASHBOARD.zoomsetting,
  firebasesetting: PATH_DASHBOARD.firebasesetting,
  gallarymanager: "/app/gallery",
  Academics: "/app/academics",
  liveclass: PATH_DASHBOARD.liveclass,
  freeliveclass: PATH_DASHBOARD.freeliveclass,
  liveclasstest: PATH_DASHBOARD.liveclasstest,
  liveclasshistory: PATH_DASHBOARD.history,
  demorequest: PATH_DASHBOARD.dobtdemorequest,
  delivery: PATH_DASHBOARD.orders,
  enquiry: PATH_DASHBOARD.enquiry,
  activitylog: PATH_DASHBOARD.activity,
  Subscription: "/app/subscription",
  packagemaster: PATH_DASHBOARD.package,
  packagedetails: PATH_DASHBOARD.packagesubscription,
  subscriptionplan: PATH_DASHBOARD.SubscriptionList,
  allindiamocktest: PATH_DASHBOARD.allindiamocktest,
  aimtinstruction: PATH_DASHBOARD.aimtinstruction,
  aimttest: PATH_DASHBOARD.aimttest,
  "All India Mock Test": PATH_DASHBOARD.allindiamocktest,
  aimtsyllabus: PATH_DASHBOARD.aimtsyllabus,
  dailytest: PATH_DASHBOARD.dailytest,
  guesspaper: PATH_DASHBOARD.guesspaper,
  about: PATH_DASHBOARD.aimtabout,
  Streak: PATH_DASHBOARD.streak,
  badges: PATH_DASHBOARD.badges,
  "Study Material": PATH_DASHBOARD.studymaterial,
  masterstudymaterial: PATH_DASHBOARD.masterstudymaterial,
  goalstudymaterialmapping: PATH_DASHBOARD.goalstudymaterialmapping,
  "Refer & Earn": PATH_DASHBOARD.referandearn,
  "userrefer&earn": PATH_DASHBOARD.userreferandearn,
  "agentrefer&earn": PATH_DASHBOARD.agentreferandearn,
  "Master Voucher": PATH_DASHBOARD.mastervoucher,
  agentvoucher: PATH_DASHBOARD.agentmastervoucher,
  voucher: PATH_DASHBOARD.voucher,
  educatorvoucher: PATH_DASHBOARD.educatorvoucher,
  walloffame: PATH_DASHBOARD.walloffame,
  "Speed Learn": PATH_DASHBOARD.speedlearn,
  speedlearnmaster: PATH_DASHBOARD.speedlearnmaster,
  speedlearnmap: PATH_DASHBOARD.speedlearnmap,
  Store: "/app/store",
  storeproduct: PATH_DASHBOARD.storeproduct,
  storeorder: PATH_DASHBOARD.storeorder,
  videocard: "/app/videocard",
};

export const IconsGenerate = (name) => (
  <SvgColor
    src={`/assets/icons/navbar/dynamic/${name}.svg`}
    sx={{ width: 1, height: 1 }}
  />
);
